define('modules/file_upload/upload_view',[
  'backbone',
  'jquery',
  '_',

  'dropzone',

  './upload_item_view',

  'modules/files/files_collection',

  'text!./upload_template.html',
  'session',
], function (
  Backbone,
  $,
  _,
  Dropzone,
  UploadItemView,
  FileCollection,
  upload_template,
  session
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      var self = this;

      _.extend(this, opts);

      this.collection = new FileCollection();

      Dropzone.autoDiscover = false;

      this.uploadUrl =
        session.get('apiUrl') +
        'files?location_id=' +
        session.get('location_id');

      this.dropzone_id = _.uniqueId('dropzone_');

      this.render();

      this.dropzone = new Dropzone('div#' + this.dropzone_id, {
        dictDefaultMessage: _.t('file.upload.message'),
        url: this.uploadUrl,
        maxFilesize: 1000,
        acceptedFiles: '.png,.jpg,.jpeg,.mp4,.mov',
        withCredentials: true,
      });

      this.dropzone.on('addedfile', function (file) {
        var fileId = self.dropzone.files.indexOf(file);
        // Task #9237 - Check for multiple "." in file name
        if (file.name.match(/\./g).length > 1) {
          self.dropzone.removeFile(file);
          Backbone.trigger('showError', 'fileUploadError', null);
        } else {
          self.trigger('fileAdded', fileId, file);
          self.startUpload(fileId, file);
        }
      });

      this.dropzone.on('uploadprogress', function (file, progress) {
        var fileId = self.dropzone.files.indexOf(file);
        self.trigger('fileProgress', fileId, file, progress);
        self.updateProgress(fileId, file, progress);
      });

      this.dropzone.on('success', function (file) {
        var fileId = self.dropzone.files.indexOf(file);
        self.trigger('fileUploaded', fileId, file);
        self.uploadComplete(fileId, file);
      });

      this.dropzone.on('error', function (file, error) {
        var fileId = self.dropzone.files.indexOf(file);
        self.trigger('fileUploadError', fileId, file, error);
        self.uploadFailed(fileId, file, error);
        var message = error.Message || null;
        Backbone.trigger('showError', 'fileUploadError', message);
      });
    },

    uploadUrl: false,
    template: _.template(upload_template),

    render: function () {
      this.$el.html(this.template({ id: this.dropzone_id }));
      this.$target_el.prepend(this.$el);
      return this;
    },

    startUpload: function (id) {
      var model = this.collection.add({ id: id, uploading: true, progress: 0 });
      var uploadFile = new UploadItemView({ model: model });
      this.$('.js-upload-files-list').append(uploadFile.$el);
    },

    updateProgress: function (id, file, progress) {
      var item = this.collection.get(id);
      item.set('progress', progress);
    },

    uploadComplete: function (id, file) {
      var item = this.collection.get(id);
      item.set(JSON.parse(file.xhr.response));
      item.set('uploading', false);
      this.trigger('fileUploadComplete', item);
    },

    uploadFailed: function (id, file, error) {
      var item = this.collection.get(id);
      item.set('remove', true);
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

